import { GridColDef } from '@microservices/wiskey-react-table-component'
import { MobileScreen } from '@mobileTypes'

export const MOBILE_SCREENS_COLUMNS: GridColDef[] = [
  {
    field: 'internalId',
    headerName: 'Internal ID',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 200,
  },
]

export const DEFAULT_MOBILE_SCREEN: Omit<MobileScreen, 'id'> = {
  internalId: '',
  title: '',
  type: 'LIST',
  backgroundColor: '#eeeeee',
}

export const SCREEN_TYPE_OPTIONS = [
  { value: 'LIST', label: 'List' },
  { value: 'FORM', label: 'Form' },
  { value: 'SPLIT', label: 'Split (Bottom Sheet)' },
  { value: 'MAP', label: 'Map (Offline)' },
]
